import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: '¿Puedo consultar por WhatsApp?',
    answer: 'Sí. Puedes escribir por WhatsApp para solicitar información y recibir orientación sobre cómo avanzar.'
  }, {
    question: '¿Atienden molestias dentales?',
    answer: 'Puedes consultar si tienes molestias dentales. La orientación final depende de una evaluación profesional.'
  }, {
    question: '¿Me dirán qué tratamiento necesito?',
    answer: 'Se puede orientar inicialmente, pero la indicación final debe realizarse después de una evaluación dental.'
  }, {
    question: '¿Evitan exámenes innecesarios?',
    answer: 'La atención busca ser clara y enfocada en lo que realmente aporta al diagnóstico o tratamiento del paciente.'
  }, {
    question: '¿Cómo puedo agendar?',
    answer: 'Puedes escribir por WhatsApp y solicitar información para coordinar tu atención.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-slate-50 py-20 lg:py-28" data-id="element-14">
      <div className="container mx-auto px-4 md:px-6" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mx-auto max-w-3xl text-center mb-12" data-id="element-16">
          <h2 className="text-3xl font-bold tracking-tight text-brand-dark sm:text-4xl" data-id="element-17">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <div className="mx-auto max-w-3xl space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="overflow-hidden rounded-2xl border border-slate-200 bg-white" data-id="element-19">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between p-6 text-left transition-colors hover:bg-slate-50" data-id="element-20">
                <span className="text-lg font-medium text-brand-dark" data-id="element-21">
                  {faq.question}
                </span>
                <ChevronDown className={`ml-4 shrink-0 text-slate-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-22" />
              </button>
              <AnimatePresence data-id="element-23">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-24">
                    <div className="border-t border-slate-100 p-6 pt-4 text-slate-600" data-id="element-25">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}